let links = $('a[href^="#"]:not(.has-dropdown)');
let siteHeader = $('.c-site-header');
let urlPage = window.location.href;
let idLink = $('#' + urlPage.split('#')[1]);


if (links.length) {
    $('.o-wrapper-body').on('click', 'a[href^="#"]:not(.has-dropdown)', function (event) {
        let targetLink = $(this).attr('href');
        $(targetLink).attr('tabindex', '0');
        $('html, body').animate({
            scrollTop: $(targetLink).offset().top - siteHeader.outerHeight() - 10
        }, function () {
            $(targetLink).focus();
        });
    });
}

if (idLink.length) {
    $(window).on('load', function () {
        $('html, body').animate({
            scrollTop: idLink.offset().top - siteHeader.outerHeight() - 10
        });
    });
}